import React from "react";

import { Share2 } from "lucide-react";

import ToolbarIconButton from "./ToolbarIconButton";
import { useDocument } from "../../documents/editor/EditorContext";
import { toast } from "@/app/_utils/toast";

export default function ShareButton() {
  const document = useDocument();

  const onClick = () => {
    const c = encodeURIComponent(JSON.stringify(document));
    location.hash = `#code/${btoa(c)}`;
    toast.success("The URL was updated. Copy it to share your current template.");
  };

  return (
    <ToolbarIconButton
      tooltip="Share current template"
      icon={<Share2 className="size-4" />}
      onClick={onClick}
    />
  );
}
